import { useEffect, useRef } from 'react'
import { Flex } from '@grammarly/design-system'

import styles from './ChatInputUphook.module.scss'
import { UnlockBestWritingUphook } from '../unlockBestWritingUphook'
import { AdvancedSuggestionsContent } from '../unlockBestWritingUphook/AdvancedSuggestionsContent'
import { GetProButtonGhost } from '../getProButtonGhost/GetProButtonGhost'

// @TODO, when more than one uphook is added, it might make sense to move common
// Types to a separate location.
type UphookWithVisibilityStatus<T> =
  | { visibilityStatus: 'hidden' }
  | { visibilityStatus: 'loading' }
  | {
      visibilityStatus: 'visible'
      data: T
    }

type ChatInputUphookModel = {
  title: string
  ctaCopy: string
  onClick: () => void
  onShow: () => void
  suggestionCount: number
  secondaryCtaCopy: string
  onSecondaryCtaClick: () => void
}

export type ChatInputUphookProps = {
  uphook: UphookWithVisibilityStatus<ChatInputUphookModel>
  children: React.ReactNode
}

export function ChatInputUphook(props: ChatInputUphookProps) {
  const { uphook, children } = props

  const showWasTracked = useRef(false)

  useEffect(() => {
    if (uphook.visibilityStatus === 'visible' && !showWasTracked.current) {
      uphook.data.onShow()
      showWasTracked.current = true
    }
  }, [uphook])

  if (uphook.visibilityStatus === 'hidden') {
    return children
  }

  return (
    <Flex direction="column" className={styles.wrapper}>
      {uphook.visibilityStatus === 'visible' ? (
        <Uphook {...uphook.data} />
      ) : (
        <div className={styles.loading} />
      )}
      {children}
    </Flex>
  )
}

const Uphook = ({
  ctaCopy,
  onClick,
  title,
  suggestionCount,
  secondaryCtaCopy,
  onSecondaryCtaClick,
}: ChatInputUphookModel) => {
  const advancedSuggestionsContent = suggestionCount > 0 && (
    <AdvancedSuggestionsContent
      suggestionCount={suggestionCount}
      secondaryCtaCopy={secondaryCtaCopy}
      onSecondaryCtaClick={onSecondaryCtaClick}
    />
  )

  return (
    <UnlockBestWritingUphook
      containerClassName={styles.uphookContainer}
      ctaButton={<GetProButtonGhost onClick={onClick}>{ctaCopy}</GetProButtonGhost>}
      title={title}
    >
      {advancedSuggestionsContent}
    </UnlockBestWritingUphook>
  )
}
